let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jMWm4")).then(() => parcelRequire('953q9'));